import React from "react";
import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "1. Delivery Area",
    body: [
      "We deliver across Nigeria. Delivery arrangements depend on the exact state, LGA, address, order size, product requirements, and transport or dispatch options available for the destination.",
      "After your order is confirmed, our team will contact you to agree the most suitable transport or dispatch arrangement for your location.",
    ],
    items: [
      "Nationwide delivery across Nigeria",
      "State, LGA, and address confirmation required",
      "Transport arrangements may vary by destination",
    ],
  },
  {
    title: "2. Processing and Delivery Times",
    body: [
      "Orders are prepared after payment confirmation and are usually dispatched as quickly as possible based on operational capacity.",
      "Estimated delivery times are communicated after order confirmation and may vary due to transport availability, weather, traffic, or other external factors.",
    ],
    items: [
      "Delivery times are estimates",
      "Orders may be processed same day where possible",
      "Delays can happen during peak periods",
    ],
  },
  {
    title: "3. Shipping Charges",
    body: [
      "Delivery fees are not automatically calculated or included in the product total at checkout.",
      "After your order is confirmed, a Zea Mays representative will contact you to confirm the delivery fee based on your location and the selected transport or dispatch option. Delivery fees are paid separately to the rider, transport provider, or dispatch service.",
    ],
  },
  {
    title: "4. Delivery Conditions",
    body: [
      "Please make sure your name, phone number, and delivery address are accurate and complete.",
      "We are not responsible for failed or delayed delivery caused by incorrect addresses, unreachable phone numbers, or customer unavailability at the delivery point.",
    ],
  },
];

const ShippingPolicyPage = () => {
  return (
    <PolicyPageLayout
      title="Shipping Policy"
      intro="This Shipping Policy explains how Zea Mays Foods handles order processing, delivery coverage, and delivery-related charges."
      sections={sections}
      contactEmail="zeamaysfood@gmail.com"
      contactPhone="+2347037038448"
      lastUpdated="July 14, 2026"
    />
  );
};

export default ShippingPolicyPage;
